import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum ReportToReceptionStep {
  Page = 'Page',
}

export const reportToReceptionFlow: CheckinWorkflow<ReportToReceptionStep> = {
  id: FlowId.ReportToReception,
  entry: ReportToReceptionStep.Page,
  steps: {
    [ReportToReceptionStep.Page]: {
      id: ReportToReceptionStep.Page,
      page: PageKey.REPORT_RECEPTION,
      next: () => ({ complete: true }),
      back: () => ({ bubble: 'back' }),
      exit: () => ({ bubble: 'exit' }),
    },
  },
};
